"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeFormat = void 0;
/**
* Enumeration of predefined formats.
* */
var DateTimeFormat;
(function (DateTimeFormat) {
    DateTimeFormat["LONG_DATE"] = "LONG_DATE";
    DateTimeFormat["LONG_DATETIME"] = "LONG_DATETIME";
    DateTimeFormat["LONG_DAY_OF_WEEK"] = "LONG_DAYOFWEEK";
    DateTimeFormat["MONTH_ABBR_DATE"] = "MONTH_ABBR_DATE";
    DateTimeFormat["SHORT_DATE"] = "SHORT_DATE";
    DateTimeFormat["SHORT_DATETIME"] = "SHORT_DATETIME";
    DateTimeFormat["SHORT_DATE_WITHOUT_YEAR"] = "SHORT_DATE_WITHOUT_YEAR";
    DateTimeFormat["SHORT_TIME"] = "SHORT_TIME";
})(DateTimeFormat || (exports.DateTimeFormat = DateTimeFormat = {}));
